import Crypto from 'crypto';

const CRYPTO_ALGORITHM = 'aes-192-cbc';

/**
 * Encrypts a string.
 *
 * @param {*} plaintext - String to encrypt.
 * @param {*} key - Encryption key.
 * @param encoding
 */
export const encrypt = (plaintext: string, key: string, encoding: BufferEncoding = 'hex'): string => {
  const cipher = Crypto.createCipher(CRYPTO_ALGORITHM, key);
  const encrypted = cipher.update(plaintext, 'utf8', encoding);
  return `${encrypted}${cipher.final(encoding)}`;
};

/**
 * Decrypts a string.
 *
 * @param {*} encrypted - String to decrypt.
 * @param {*} key - Decryption key.
 * @param encoding
 */
export const decrypt = (encrypted: string, key: string, encoding: BufferEncoding = 'hex'): string => {
  const decipher = Crypto.createDecipher(CRYPTO_ALGORITHM, key);
  const plaintext = decipher.update(encrypted, encoding, 'utf8');
  return `${plaintext}${decipher.final('utf8')}`;
};
/**
 * Generate SHA-256 hash of string
 *
 * @param {string} plaintext
 * @returns {string} SHA-256 hash
 */
export const sha256 = (plaintext: string): string =>
  Crypto.createHash('sha256').update(plaintext, 'utf8').digest('hex');
